import {Command, EditorState, Transaction, TextSelection} from "prosemirror-state";
import { Node as ProseMirrorNode, Schema } from "prosemirror-model";



export function insertTableCommand(columns:number, rows:number, headerColumns = 0, headerRows = 1):Command {

	return (state:EditorState, dispatch?) => {
		const nodes = state.schema.nodes;
		const tableType = nodes.table;
		const tableRowType = nodes.table_row;
		const tableCellType = nodes.table_cell;
		const tableHeaderType = nodes.table_header;

		if (!tableType || !tableRowType || !tableCellType || !tableHeaderType) return false;

		// Helper to create an empty cell
		const createCell = (isHeader = false): ProseMirrorNode => {
			const cellType = isHeader ? tableHeaderType : tableCellType;
			return cellType.createAndFill()!;
		};

		// Build the table node
		const tableNode = tableType.create(null /* attrs empty */,
			Array.from({ length: rows }, (_, rowIndex) =>
				tableRowType.create(null /* row attrs empty */,
					Array.from({ length: columns }, (_, colIndex) => createCell(rowIndex < headerRows || colIndex < headerColumns))
				)
			)
		);
		if (!tableNode) return false;	// failed to create

		// Replace the current selection with the table
		const tr = state.tr;
		const { from, to, $cursor } = state.selection as TextSelection;
		let tableStart = from;

		if ($cursor) {
			const isEmpty = $cursor.parent.content.size === 0;
			const cursorAtStart = $cursor.pos === $cursor.start();
			const cursorAtEnd = $cursor.pos === $cursor.end();
			let inserted = false;
			if (isEmpty) {
				// Replace empty block with the new table
				const toReplace = $cursor.parent;
				tr.replaceWith($cursor.pos - 1, $cursor.pos + 1, tableNode);
				tableStart = $cursor.pos - 1;
				inserted = true;
			} else if (cursorAtStart) {
				// Insert table before this block
				const pos = $cursor.before();
				tr.insert(pos, tableNode);
				tableStart = pos;
				inserted = true;
			} else if (cursorAtEnd) {
				const pos = $cursor.after();
				tr.insert(pos, tableNode);
				tableStart = pos;
				inserted = true;
			}
			if (inserted) {
				tr.setSelection(TextSelection.create(tr.doc, tableStart + 4));
				if (dispatch) dispatch(tr.scrollIntoView());
				return true;
			}
		}

		tr.replaceWith(from, to, tableNode);
		// Find the position of the first cell's content
		const firstCellPos = from + 5; // First cell's content
		// Set the selection to the first cell's content
		tr.setSelection(TextSelection.create(tr.doc, firstCellPos));
		if (dispatch) dispatch(tr.scrollIntoView());
		return true;
	};
}